<div class="container pt-3" >
  <mat-card class="p-0 mb-4" *ngIf="headerName">
    <div class="d-flex justify-space-between align-items-center w-100">
      <div class="d-flex align-items-center">
        <div mat-card-avatar class="example-header-image">
          <img loading="lazy" [src]="headerName?.image" 
            [ngClass]="{'radius-50 shadow': environmentVariables?.CATEGORY_CARD == 'round'}"
            [alt]="headerName?.image" 
            onError="this.src='./assets/images/placeholder70.png';" 
          />
        </div>
        <h1 class="ml-3 mt-1" style="font-size: 20px !important;" [ngClass]="{'arabic-font' : lang === 'ar'}">
          {{
            lang == "ar" && headerName?.name_ar
              ? headerName?.name_ar
              : headerName?.name
          }}
        </h1>
      </div>
      <div class="view-all">
        <span (click)="viewAllCategories()">
          {{"button.viewAll" | translate}}
        </span>
      </div>
    </div>
  </mat-card>
 
  <ng-container *ngIf="environmentVariables?.CATEGORY_VIEW_STYLE == 'groups_only'">
    <div  class="categories-collection pb-4">
      <ng-container *ngIf="loading && !categoriesPage; else notLoading">
        <div class="parent-container"  *ngFor="let item of fakeArray"
          >
          <div class="content mb-3" >
            <div class="light-animate-shimmer image-shimmer"
            [ngClass]="{'radius-50 shadow' :  environmentVariables?.CATEGORY_CARD == 'round'}"
            ></div>
          </div>
          <div class="light-animate-shimmer description-shimmer"></div>
        </div>
      </ng-container>

      <ng-template #notLoading>
        <div class="parent-container pb-4" *ngFor="let item of arrayList"
        >
          <a
          style="margin: 0px auto !important"
          class="brand-item"
          *ngIf="item?.itemType === 'category' ; else itemNotCategory"
          (click)="routeToGroup(item)"
          >
          <div class="content imgContainer mx-2 mt-2">
            <img  loading="lazy"  [src]="item.itemImage" 
            [ngClass]="{'radius-50 shadow' :  environmentVariables?.CATEGORY_CARD == 'round'}"
              [alt]="item.itemImage" 
            onError="this.src='./assets/images/placeholder70.png';" 
            style="
            position: relative;
            top: 0px;
            left: 0px;
            margin-left: 0px;
            margin-right: 0px;
            object-fit: contain;
            "
            />
            <h3 class="text-center product-text mt-3">{{ item.itemName }}</h3>
          </div>
          </a>
          <ng-template #itemNotCategory>
            <a
          style="margin: 0px auto !important"
          class="brand-item"
          (click)="viewSubCategory(item)"
          >
          <div class="content imgContainer mx-2 mt-2">
            <img  loading="lazy"  [src]="item.itemImage" 
            [ngClass]="{'radius-50 shadow' :  environmentVariables?.CATEGORY_CARD == 'round'}"
              [alt]="item.itemImage" 
            onError="this.src='./assets/images/placeholder70.png';" 
            style="
            position: relative;
            top: 0px;
            left: 0px;
            margin-left: 0px;
            margin-right: 0px;
            object-fit: contain;
            "
            />
            <h3 class="text-center product-text mt-3">{{ item.itemName }}</h3>
          </div>
          </a>
        </ng-template>
      
        </div>
      </ng-template>
    </div>
  </ng-container>

  <ng-container *ngIf="environmentVariables?.CATEGORY_VIEW_STYLE == 'groups_with_subcategories'">
    <mat-card class="example-card my-3 pb-5" *ngFor="let item of arrayList" [ngClass]="{'d-none' : item?.sub_categories?.length == 0 }">
      <ng-container *ngIf="item?.sub_categories?.length > 0">
        <mat-card-header class="mb-4 mx-2">
          <div mat-card-avatar class="example-header-image">
              <img  loading="lazy"  [src]="item?.itemImage" 
              [ngClass]="{'radius-50 shadow' :  environmentVariables?.CATEGORY_CARD == 'round'}"
                [alt]="item?.itemImage" 
              onError="this.src='./assets/images/placeholder70.png';" 
              />
          </div>

          <div class="d-flex justify-space-between align-items-center w-100">
          <h1 class="mt-1 group-title" style="font-size: 20px !important;">{{item?.itemName}}</h1>

          <div class="view-all">
            <span (click)="viewAllGroups(item)">
            {{"button.viewAll" | translate}}
            </span>
          </div>
          </div>
        </mat-card-header>
        <mat-card-content>
          <div  class="categories-collection pb-4 sub-category-collection" >
            <ng-container *ngIf="loading && !categoriesPage; else notLoading">
              <div class="parent-container"  *ngFor="let item of fakeArray"
                >
                <div class="content mb-3" >
                  <div class="light-animate-shimmer image-shimmer"></div>
                </div>
                <div class="light-animate-shimmer description-shimmer"></div>
              </div>
            </ng-container>
            <ng-template #notLoading>
              <div class="parent-container" *ngFor="let sub of item?.sub_categories">
                <a
                  (click)="viewSubCategory(sub , item)"
                  style="margin: 0px auto !important"
                  class="brand-item"
                >
                <div class="content imgContainer mx-2 mt-2" >
                  <img  loading="lazy"  [src]="sub?.image" 
                  [ngClass]="{'radius-50 shadow' :  environmentVariables?.CATEGORY_CARD == 'round'}"
                    [alt]="sub?.image" 
                  onError="this.src='./assets/images/placeholder70.png';" 
                  style="
                  position: relative;
                  top: 0px;
                  left: 0px;
                  margin-left: 0px;
                  margin-right: 0px;
                  object-fit: contain;
                  border-radius: 50%;
                  "
                  />
                  <h3 class="text-center mt-3 product-text">{{ 
                    lang == "ar" 
                    ? sub?.name_ar
                    : sub?.name
                  }}
                </h3>
        
                </div>
                </a>
              </div>
            </ng-template>
          </div>
    
        </mat-card-content>
      </ng-container>
    </mat-card>
  </ng-container>

  <ng-container *ngIf="currentPageViewUrl?.length > 0 && environmentVariables?.ENABLE_GROUPS_SECTION && environmentVariables?.    CATEGORY_VIEW_STYLE == 'groups_only' ">
    <div class="mt-4">
      <app-home-sections [currentPageView]="currentPageViewUrl"></app-home-sections>
    </div>
  </ng-container>
</div>

<ng-container *ngIf="currentSubCategoryPageViewUrl?.length > 0 && environmentVariables?.ENABLE_SUBCATEGORIES_SECTION && environmentVariables?.CATEGORY_VIEW_STYLE == 'groups_only'">
  <div class="mt-4">
    <app-home-sections [currentPageView]="currentSubCategoryPageViewUrl"></app-home-sections>
  </div>
</ng-container>